/*
 * A&M JOYAS - Selector opcional de "producto adicional" en la página de un
 * producto principal (snippets/product-addon-picker.liquid).
 *
 * Soporta dos modos:
 * - Checkbox único (una sola variante del adicional).
 * - Selector de opciones tipo radio (varias variantes, ej. "1 unidad" /
 *   "2 unidades" con precio combo) — ninguna marcada por defecto.
 *
 * Los radios nativos del navegador no se pueden "desmarcar" haciendo clic
 * de nuevo sobre el que ya está seleccionado (solo permiten cambiar a otra
 * opción). Para que la clienta pueda arrepentirse y quitar la selección por
 * completo (sin tener que elegir la otra opción), se agrega ese
 * comportamiento a mano: se recuerda si el radio ya estaba marcado justo
 * antes del clic (mousedown), y si lo estaba, el clic lo desmarca en vez de
 * dejarlo marcado.
 *
 * Cuando la clienta marca/selecciona algo y hace clic en "Agregar al
 * carrito" del producto principal, este script agrega también el producto
 * adicional al carrito en una segunda llamada, apenas se confirma que el
 * producto principal se agregó (evento cartUpdate de Dawn).
 */
(function () {
  if (window.__addonPickerInit) return;
  window.__addonPickerInit = true;

  function inicializar(el) {
    var submitId = el.getAttribute('data-addon-submit-id');
    var btn = document.getElementById(submitId);
    if (!btn) return;

    var checkbox = el.querySelector('.product-addon-option__checkbox');
    var radios = el.querySelectorAll('.product-addon-choice__radio');
    var fixedVariantId = el.getAttribute('data-addon-variant-id');

    if (!checkbox && radios.length === 0) return;

    radios.forEach(function (radio) {
      // OJO: el mousedown hay que escucharlo en la etiqueta (label) completa,
      // no en el radio mismo. La clienta normalmente hace clic sobre el
      // texto ("Agregar 1", el precio, etc.), no sobre el punto exacto del
      // radio: en ese caso el navegador dispara mousedown sobre el texto
      // (un hermano del radio, no un descendiente), así que un listener
      // puesto directo en el radio nunca se entera. Puesto en el label sí,
      // porque el label es antecesor tanto del radio como del texto.
      var etiqueta = radio.closest('label') || radio.parentElement;
      etiqueta.addEventListener('mousedown', function () {
        radio.dataset.wasChecked = radio.checked ? 'true' : 'false';
      });
      radio.addEventListener('click', function () {
        if (radio.dataset.wasChecked === 'true') {
          radio.checked = false;
        }
      });
    });

    var pendiente = false;
    var variantIdAAgregar = null;

    btn.addEventListener('click', function () {
      if (checkbox) {
        pendiente = checkbox.checked;
        variantIdAAgregar = fixedVariantId;
      } else if (radios.length) {
        var seleccionado = null;
        radios.forEach(function (r) {
          if (r.checked) seleccionado = r;
        });
        pendiente = !!seleccionado;
        variantIdAAgregar = seleccionado ? seleccionado.value : null;
      }
    });

    function agregarAdicionalAlCarrito() {
      if (!pendiente || !variantIdAAgregar) return;
      pendiente = false;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantIdAAgregar, quantity: 1 }),
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (checkbox) checkbox.checked = false;
          radios.forEach(function (r) { r.checked = false; });
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-addon-picker' });
          }
        })
        .catch(function () {});
    }

    function suscribirse() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
          if (evt && evt.source === 'product-addon-picker') return;
          agregarAdicionalAlCarrito();
        });
      } else {
        setTimeout(suscribirse, 250);
      }
    }
    suscribirse();
  }

  function init() {
    document.querySelectorAll('[data-addon-picker]').forEach(inicializar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
